import { render, staticRenderFns } from "./SelectCustomer.vue?vue&type=template&id=b22c0fa4&scoped=true&"
import script from "./SelectCustomer.vue?vue&type=script&lang=js&"
export * from "./SelectCustomer.vue?vue&type=script&lang=js&"
import style0 from "./SelectCustomer.vue?vue&type=style&index=0&id=b22c0fa4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22c0fa4",
  null
  
)

export default component.exports